import React from "react";
import { useDispatch } from "react-redux";
import { changeSearchTerm } from "../../features/filter/filterSlice";

const Navbar = () => {
  const dispatch = useDispatch()
  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <a href="./index.html">
          <img src="./images/logo.svg" />
        </a>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Task"
            className="search-input"
            id="lws-searchTask"
            onChange={(e)=> dispatch(changeSearchTerm(e.target.value)) }
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
